import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointTablet,
  BreakPointDesktop,
  BreakPointMobile,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    background:
      "linear-gradient(180deg, rgba(16, 16, 16, 0.98) 0%, rgba(9, 9, 9, 0.98) 100%)",
    gap: theme.spacing.space8,
    display: "flex",
    flexDirection: "column",
    padding: `0px ${theme.spacing.space24}px`,
    boxSizing: "border-box",
    borderRadius: theme.radius.large,
    width: "-webkit-fill-available",
    overflow: "hidden",
    [BreakPointDesktop]: {
      "&:hover": {
        transform: "scale(1.02)",
      },
    },
  },
  options: {
    display: "flex",
    paddingTop: theme.spacing.space16,
    gap: theme.spacing.space8,
  },
  gamePad: {
    display: "flex",
    alignItems: "center",
    width: 65,
    [BreakPointTablet]: {
      width: 75,
    },
    [BreakPointDesktop]: {
      width: 114,
    },
  },
  image: {
    width: "100%",
  },
  value: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space8,
  },
  selected: {
    outline: "2px solid rgba(255, 255, 255, 0.80)",
    outlineOffset: 2,
    // webOS 22 (Chromium <=87): outline ignores border-radius; box-shadow follows it
    "@supports not (aspect-ratio: 1 / 1)": {
      outline: "none",
      boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.80)",
    },
  },
  noDevice: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "100%",
  },
  gamepad: {
    flex: 1,
    height: 150,
    position: "relative",
    [BreakPointMobile]: {
      flex: "0.7",
      height: 120,
    },
    [BreakPointDesktop]: {
      height: "100%",
    },
    [BreakPointTablet]: {
      height: 190,
    },
  },
  noPadding: {
    padding: 0,
    display: "block",
    [BreakPointMobile]: {
      marginTop: theme.spacing.space32,
    },
    [BreakPointTablet]: {
      marginTop: theme.spacing.space40,
    },
  },
  noDeviceValue: {
    padding: `${theme.spacing.space24}px 0px ${theme.spacing.space24}px ${theme.spacing.space24}px`,
    flex: 1,
  },
  imageDevice: {
    position: "absolute",
    right: -17,
    height: "100%",
    bottom: -35,
  },
}));
